import { render } from "./DishInMenuCardComponent.vue?vue&type=template&id=18d6f33b&scoped=true"
import script from "./DishInMenuCardComponent.vue?vue&type=script&lang=js"
export * from "./DishInMenuCardComponent.vue?vue&type=script&lang=js"

import "./DishInMenuCardComponent.vue?vue&type=style&index=0&id=18d6f33b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d6f33b"]])

export default __exports__